import { createSlice } from '@reduxjs/toolkit';
import { getPacsData } from '../../../rtk-apis/pacs/getPacs';

const initialState = {
  status: '',
  result: null,
  msg: '',
  loading: false,
  error: '',
};

const getPacsDataSlice = createSlice({
  name: 'getPacsData',
  initialState,
  reducers: {
    clearState: state => {
      state.status = '';
      state.result = null;
      state.msg = '';
      state.loading = false;
      state.error = '';
    },
  },
  extraReducers: builder => {
    builder
      .addCase(getPacsData.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getPacsData.fulfilled, (state, action) => {
        state.loading = false;
        state.status = 'SUCCESS';
        state.result = action?.payload;
        state.msg = action?.payload?.msg;
      })
      .addCase(getPacsData.rejected, (state, action) => {
        state.loading = false;
        state.status = 'ERROR';
        state.result = null;
        state.msg = (action?.payload as string) || 'Something went wrong!';
      });
  },
});

export default getPacsDataSlice.reducer;
export const { clearState } = getPacsDataSlice.actions;
